const { DataServiceEndPoint } = require("@cloudbreakus/network-utilities")

class Gender extends DataServiceEndPoint {
  static key = "Gender"

  getGenders = async () => {
    const response = await this._httpService.get(`${this.url}/v1/genders`, {
      headers: { Authorization: `bearer ${this.token}` },
      "axios-retry": {
        retries: 3,
      },
    })
    return response
  }

  getTransferGenderOptions = async () => {
    const response = await this._httpService.get(`${this.url}/v1/genders/transfer-options`, {
      headers: { Authorization: `bearer ${this.token}` },
      "axios-retry": {
        retries: 3,
      },
    })
    return response
  }

  updateAgentGender = async ({ agentId, genderId }) => {
    const response = await this._httpService.put(
      `${this.url}/v1/agents/${agentId}/gender`,
      { genderId },
      { headers: { Authorization: `bearer ${this.token}` } }
    )
    return response
  }
}

module.exports = Gender
